import React from 'react';
import './Sunburst/dataviz.css';
import ProductGlobalContextProvider from '../context/ContextDataViz';
import FilterComponents from './FilterComponents';
import SunburstContainerData from './Sunburst/SunburstContainerData';
import DataGlobal from './Sunburst/DataGlobal';
import { Section } from '../../../Components/Section/Section';
import { PageBreadcrumb } from '../../../Components/Page/PageBreadcrumb';
import { useTranslation } from 'react-i18next';

export default function DataVizualization(props) {

	const [t] = useTranslation('kpi');

	if (location.pathname !== '/Insight/sunburst') {
		return <></>;
	}

	return (
		<div>
			<ProductGlobalContextProvider
				$http={props.$http}
				$rootScope={props.$rootScope}
				$routeParams={props.$routeParams}
				$timeout={props.$timeout}
				AuthServices={props.AuthServices}
				accountId={props.accountId}
				$location={props.$location}
			>
				<Section width='m'>
					<section className='section no_bottom_pad section_primary'>
						<PageBreadcrumb>
							<span className='h1'>{t('traffic.traffic')}</span>
							<span className='h1'>{t('visitorJourney.visitorJourney')}</span>
						</PageBreadcrumb>
					</section>
					<section className='section'>
						<FilterComponents />
						<DataGlobal />
						<SunburstContainerData />
					</section>
				</Section>
			</ProductGlobalContextProvider>
		</div>
	);
}
